import { render, staticRenderFns } from "./RegionalSalesSummaryList.vue?vue&type=template&id=35f5013b&scoped=true&"
import script from "./RegionalSalesSummaryList.vue?vue&type=script&lang=js&"
export * from "./RegionalSalesSummaryList.vue?vue&type=script&lang=js&"
import style0 from "./RegionalSalesSummaryList.vue?vue&type=style&index=0&id=35f5013b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f5013b",
  null
  
)

export default component.exports